const reportes1 = [
    { id: 1, titulo: "Listado de usuarios", subtitulo: "Con permisos", url: "http://GYF04:80/Reports_SQL2012" },
    { id: 2, titulo: "Listado de usuarios", subtitulo: "Por sector", url: "http://GYF04:80/Reports_SQL2012" },
    { id: 3, titulo: "Listado de usuarios", subtitulo: "Por perfil", url: "http://GYF04:80/Reports_SQL2012" },
    { id: 4, titulo: "Listado de usuarios", subtitulo: "Sin ingreso al sistema", url: "http://GYF04:80/Reports_SQL2012" },
    { id: 1, titulo: "Listado de usuarios", subtitulo: "Dados de baja", url: "http://GYF04:80/Reports_SQL2012" },
    { id: 1, titulo: "Listado de usuarios", subtitulo: "Opcion Uno", url: "http://GYF04:80/Reports_SQL2012" }
];

const reportes2 = [
    { id: 1, titulo: "Reporte novedades", subtitulo: "Rechazadas", url: "http://GYF04:80/Reports_SQL2012" }
];

const reportesGrupo = [
    { nombre: "Usuarios y Permisos", reportes: reportes1 },
    { nombre: "Novedades", reportes: reportes2 }
];

const initialState = {
    isFetching: false,
    reportes: reportesGrupo,
    nombre: ""
}

export default function invocadorReportes(state = initialState, action)
{
    return state;
}